module.exports = __webpack_public_path__ + "static/media/businesses.2e25ad44.svg";